import React from 'react';
import { 
    Flex, 
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Button,
    Text
} from '@chakra-ui/react';
import { BsChevronDown } from 'react-icons/bs';
import { SortProps } from '../../../types/ui';
import { sortValues } from '../../../utilities/dummy';

export default function CustomSort({ sortValue = 'Newest', onSort }: SortProps) {
    function handleSort(value: string) {
        onSort && onSort(value)
    }

    return (
        <Flex direction={'row'} align='center' justify='flex-end'>
           <Menu size={'sm'} variant='outline'>
                <MenuButton 
                    as={Button} 
                    rightIcon={<BsChevronDown />} 
                    fontSize='sm'
                    bg='transparent'
                    border='1px solid #E2E8F0'
                    _hover={{ bg: 'transparent' }}
                    _expanded={{ bg: 'transparent' }}
                    _focus={{ boxShadow: 'none', bg: 'transparent' }} 
                    paddingX='2.5'
                    paddingY='0.5'
                    height={'8'}
                    minWidth='180px'
                >
                    <Flex>
                        <Text fontSize={'xs'} color='gray.500' marginRight='1.5'>Sort by:</Text>
                        <Text fontSize={'xs'} color='gray.700' fontWeight={'semibold'}>{sortValue}</Text>
                    </Flex>
                </MenuButton>
                <MenuList>
                    {sortValues.map(item => (
                        <MenuItem fontSize={'sm'} onClick={() => handleSort(item)}>{item}</MenuItem>
                    ))}
                </MenuList>
            </Menu>
        </Flex>
    )
}